import { apiService } from '../_services'

const state = {
    unreadNotes: []
}

const getters = {
  getUnreadNotes: (state) => {
    state.unreadNotes
  },
}

const actions = {
  fetchUnreadNotes: (context) => {
    console.log('action: fetchUnreadNotes')
    apiService.getUnreadNotes()
    .then((response) => {
      console.log({response})
      // vm.unread = response.data
      context.commit('SET_UNREAD_MESSAGES', response.data)
    })
  },
}

const mutations = {
  SET_UNREAD_MESSAGES: (state, unread) => {
    state.unreadNotes = unread
  },
}

export const notes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/_store/notes.module.js